import { Component } from 'react';
import { Accordion, Alert, Button, Card, Form } from "react-bootstrap";
import GameData from "../mobx/GameData";
import { observe } from 'mobx';
import ApplicationState from "../mobx/ApplicationState";
import GraphicsPatcher from "../components/services/GraphicsPatcher";
import { Col, Row, Container } from "react-bootstrap";

import './MusicPage.scss';
import { coerceUnknownFields } from '../data/BaseGame';
import MusicPlayTimes, { getMusicPositionName } from '../data/MusicPlayTimes';

export default class MusicPage extends Component {

    thisId = null;
    gameDataCleanup = null;
    BuiltInSongs = [];

    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
        const game = coerceUnknownFields(GameData.currentGame);

        this.state = {
            titleSong: game.titleSong ?? 0,
            gameplaySong: game.gameplaySong ?? 0,
            creditsSong: game.creditsSong ?? 0,
            loading: true,
            usingBuiltInMusic: !!game.usingBuiltInMusic,
            soundtrackData: game.soundtrackData ?? [],
            customSongCount: game.customSongCount,
            customSongUsage: game.customSongUsage
        }
    }

    async componentDidMount() {
        this.gameDataCleanup = observe(GameData, () => { 
            this.forceUpdate()
        });

        const bis = await import ('../data/BuiltInSongs');
        this.BuiltInSongs = bis.default;
        this.setState({loading: false});
    }

    componentWillUnmount() {
        if (this.gameDataCleanup) {
            this.gameDataCleanup();
        }
    }

    async customEnabled() {
        await new Promise(resolve => this.setState({
            usingBuiltInMusic: document.getElementById('use-builtin-music-yes').checked,
        }, resolve)); 
        ApplicationState.setCurrentPageUnsaved();
    }

    fieldChanged(name) {
        this.setState({[name]: parseInt(document.getElementById(name).value, 10)});
        this.forceUpdate();
        ApplicationState.setCurrentPageUnsaved();
    }

    songChanged(i) {
        const customSongUsage = JSON.parse(JSON.stringify(this.state.customSongUsage));
        customSongUsage[i].showAt = parseInt(document.getElementById('song-' + i).value, 10);
        if (customSongUsage[i].showAt === MusicPlayTimes.OnScreen) {
            customSongUsage[i].showAtDetail = coerceUnknownFields(GameData.currentGame).staticScreens[0].id;
        } else {
            customSongUsage[i].showAtDetail = 0;
        }
        this.setState({customSongUsage});
        ApplicationState.setCurrentPageUnsaved();
    }

    songDetailChanged(i, fieldSuffix) {
        const customSongUsage = JSON.parse(JSON.stringify(this.state.customSongUsage));
        if (fieldSuffix === 'lvl') {
            customSongUsage[i].showAtDetail = parseInt(document.getElementById('song-' + i + '-' + fieldSuffix).value, 10);
        } else {
            customSongUsage[i].showAtDetail = document.getElementById('song-' + i + '-' + fieldSuffix).value;
        }
        this.setState({customSongUsage});
        ApplicationState.setCurrentPageUnsaved();
    }

    songIdChanged(i) {
        const customSongUsage = JSON.parse(JSON.stringify(this.state.customSongUsage));
        customSongUsage[i].songId = parseInt(document.getElementById('song-id-' + i).value, 10);
        this.setState({customSongUsage});
        ApplicationState.setCurrentPageUnsaved();
    }
    
    async fileUpload(eType, event) {
        let field, maxlength;
        switch (eType) {
            case 'binFile': field = 'soundtrackData'; maxlength = 10240; break;
            default: throw new Error('Unknown eType: ' + eType);
        }
        const file = document.getElementById(eType).files[0];
        let data = new Uint8Array(await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result)
            reader.onerror = (e) => reject(e);

            reader.readAsArrayBuffer(file);
        }));

        if (data.length > maxlength) {
            ApplicationState.addAlert('danger', 'Unable to load file - it must be no more than ' + maxlength + ' bytes in size! Check the FAQ at the bottom for help.');
            return;
        }

        await new Promise(resolve => this.setState({[field]: Array.from(data)}, resolve));
        this.forceUpdate();


        ApplicationState.setCurrentPageUnsaved();
    }


    async saveChanges(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }

        if (!this.state.usingBuiltInMusic && this.state.soundtrackData.length === 0) {
            ApplicationState.addAlert('warning', 'No custom music data was loaded, so this game cannot be saved. Please upload a file, or switch to built-in music.');
            return;
        }

        let updatedGame;
        if (this.state.usingBuiltInMusic) {
            updatedGame = {
                ...GameData.currentGame,
                usingBuiltInMusic: true,
                soundtrackData: [],
                titleSong: this.state.titleSong,
                gameplaySong: this.state.gameplaySong,
                creditsSong: this.state.creditsSong
            };
        } else {
            updatedGame = {
                ...GameData.currentGame,
                usingBuiltInMusic: false,
                soundtrackData: this.state.soundtrackData,
                customSongCount: this.state.customSongCount,
                customSongUsage: this.state.customSongUsage
            };
        }
        updatedGame.creditsScreenData = await GraphicsPatcher.getPatchedCreditsDataForGame(updatedGame);
        GameData.replaceCurrentGame(updatedGame);

        // SUCCESS! Share the update!
        ApplicationState.addAlert('success', 'Music updated successfully.');
        ApplicationState.unsetCurrentPageUnsaved();
        
    }

    render() {
        let mainForm
        let bottomStuff
        if (this.state.loading || ApplicationState.emulatorIsVisible) { return <></> }
        if (this.state.usingBuiltInMusic) {
            mainForm = <>
                <h3 className="mb-2 mt-3">Built-in song selection</h3>
                {(GameData.currentGame.usingBuiltInMusic !== this.state.usingBuiltInMusic) ? (
                    <Alert variant="warning"><strong>Warning:</strong> Going back to built-in music after using custom music will erase your custom music! Saving this way will also re-add the musicians to the credits screen.</Alert>
                ) : ''}

                <Form.Group className="mb-3">
                    <Form.Label htmlFor="titleSong">Title Song</Form.Label>
                    <Form.Select arial-label="Select an song" onChange={() => this.fieldChanged('titleSong')} defaultValue={this.state.titleSong} id="titleSong">
                        {this.BuiltInSongs.map(opt => {
                            return <option key={opt.id} value={opt.id}>{opt.title} (by {opt.author})</option>
                        })}
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label htmlFor="gameplaySong">Main Song</Form.Label>
                    <Form.Select arial-label="Select an song" onChange={() => this.fieldChanged('gameplaySong')} defaultValue={this.state.gameplaySong} id="gameplaySong">
                        {this.BuiltInSongs.map(opt => {
                            return <option key={opt.id} value={opt.id}>{opt.title} (by {opt.author})</option>
                        })}
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label htmlFor="creditsSong">Credits Song</Form.Label>
                    <Form.Select arial-label="Select an song" onChange={() => this.fieldChanged('creditsSong')} defaultValue={this.state.creditsSong} id="creditsSong">
                        {this.BuiltInSongs.map(opt => {
                            return <option key={opt.id} value={opt.id}>{opt.title} (by {opt.author})</option>
                        })}
                    </Form.Select>
                </Form.Group>
            </>

            bottomStuff = <>
                <div className="mt-3 song-cards">
                    <h2>Music Credits</h2>
                    {this.BuiltInSongs.map(song => (
                        <Card key={song.id} className="mb-3">
                            <Card.Body>
                                <Card.Title><a target="_blank" rel="noreferrer" href={song.link}>{song.title}</a></Card.Title>
                                    <table className="mt-3"><tbody>
                                        <tr>
                                            <td>Author: </td>
                                            <td><a target="_blank" rel="noreferrer" href={song.authorLink}>{song.author}</a></td>
                                        </tr>
                                        <tr>
                                            <td>Source: </td>
                                            <td><a target="_blank" rel="noreferrer" href={song.sourceLink}>{song.source}</a></td>
                                        </tr>
                                        <tr>
                                            <td>License: </td>
                                            <td><a target="_blank" rel="noreferrer" href={song.licenseLink}>{song.license}</a></td>
                                        </tr>
                                    </tbody></table>
                            </Card.Body>
                        </Card>
                    ))}
                </div>
            </>
        } else {
            const game = coerceUnknownFields(GameData.currentGame);
            const songList = [];
            for (let i = 0; i < this.state.customSongCount; i++) {
                songList.push(i);
            }
            let songFields = this.state.customSongUsage.map((song, i) => {
                return (<Row key={`song-${i}`} className="mb-3">
                    <Col />
                    <Col>
                        <Form.Select arial-label="Select a song" onChange={() => this.songIdChanged(i)} defaultValue={song.songId ?? i} id={`song-id-${i}`}>
                            {songList.map(num => {
                                return <option key={num} value={num}>Song {num+1}</option>
                            })}
                        </Form.Select>

                    </Col>
                    <Col>
                        <Form.Select arial-label="Select a time to play" onChange={() => this.songChanged(i)} defaultValue={song.showAt} id={`song-${i}`}>
                            {Object.values(MusicPlayTimes).map(num => {
                                return <option key={num} value={num}>{getMusicPositionName(num)}</option>
                            })}
                        </Form.Select>
                    </Col>
                    <Col>
                        <Form.Select style={{display: song.showAt === MusicPlayTimes.OnLevel ? null : 'none'}} aria-label="Select a level to play after" onChange={() => this.songDetailChanged(i, 'lvl')} defaultValue={song.showAtDetail} id={`song-${i}-lvl`}>
                            {Array.from({length: GameData.currentGame.lastLevel+1}, (_, i) => i).map(i => (<option key={i} value={i}>Level {i+1}</option>))}
                        </Form.Select>
                        <Form.Select style={{display: song.showAt === MusicPlayTimes.OnScreen ? null : 'none'}} aria-label="Select a level to play after" onChange={() => this.songDetailChanged(i, 'screen')} defaultValue={song.showAtDetail} id={`song-${i}-screen`}>
                            {game.staticScreens.map(s => (<option key={s.id} value={s.id}>{s.title}</option>))}
                        </Form.Select>

                    </Col>
                    <Col />
                </Row>);
            });
            mainForm = <>
                <h3 className="mb-2 mt-3">Custom music</h3>
                <p>You can upload a custom music file below. Music should be created as separate songs in famitracker, and exported as raw music data. See the FAQ at the bottom for details, and links to tools you can use!</p>
                <Container className="upload-form">
                    <Row>
                        <Col md={8} sm={12}>
                            <Form.Group controlId="binFile" className="mb-3">
                                <Form.Label>Music Data (famitracker nes .bin format, under '10kb')</Form.Label>
                                <Form.Control type="file" name="binFile" accept=".bin" onChange={event => this.fileUpload('binFile', event)} />
                            </Form.Group>
                            <div>
                                {this.state.soundtrackData.length > 0 ? 'Music data loaded (' + this.state.soundtrackData.length + ' bytes)' : 'Music data not loaded'}
                            </div>
                        </Col>
                        <Col md={4} sm={12}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="customSongCount">Song Count</Form.Label>
                                <Form.Select arial-label="Select an song" onChange={() => this.fieldChanged('customSongCount')} defaultValue={this.state.customSongCount} id="customSongCount">
                                    {Array.from({length: 13}, (_, i) => i+3).map(i => (<option key={i} value={i}>{i}</option>))}
                                </Form.Select>
                            </Form.Group>

                        </Col>
                    </Row>
                    <h4 className="mt-3 mb-3">When to play songs</h4>
                    {songFields}
                </Container>
            </>

            bottomStuff = <div className="mt-4">
                <h2>Music FAQs</h2>
                <Accordion className="mt-3" defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>How can I create music?</Accordion.Header>
                        <Accordion.Body>
                            <p>
                                You can create music compatible with this engine using a tool called{' '}
                                <a href="https://web.archive.org/web/20230302081117/http://famitracker.com/">Famitracker</a>. (The original version 0.4.6 is the only one officially supported. Forks could work but are unsupported.)
                            </p>

                            <p className="no-bottom">
                                You should have at least 3 songs in the file, which can be set up to play at certain times in the game.
                            </p>

                            <p>
                                All features of famitracker are supported, except for DPCM. (DPCM complicates implementation and requires a good bit of space)
                            </p>
                            <p>
                                To export in a format this tool understands, go to the "File" menu and choose the "Create NSF" option. You can leave all fields blank, but 
                                change "Type of file" to "BIN- Raw Music Data". Hit export and upload the resulting bin file in the form above.
                            </p>
                            <p>
                                Be warned that if you have fewer than 3 songs, the game may crash. If you have fewer songs, add empty songs to the 
                                game so there are 3. There is no issue with having more than 3 songs.
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Why do I have to enter a song count? Why is the count wrong?</Accordion.Header>
                        <Accordion.Body>
                            <p>
                               Famitracker's export doesn't give an easy way to determine how many songs are in exported binary files, so the
                               tool actually has no way to know how many songs are in it. It also does not give their titles, or anything of the sort. 
                            </p>

                            <p>
                                As a result, the tool has to ask you how many songs there are. Hopefully this is only a minor inconvenience.
                            </p>
                            <p>
                                Please be aware that if the game tries to play a song that is not in your export, it may crash or behave unexpectedly.
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
        }
        return (
            <Container className="music-page">
                <Row>
                    <Col>
                        <h1>Music</h1>

                        <p>Choose the songs to listen to in your game here.</p>
                        <p>For now, you can listen to the songs by changing your title song, hitting save, then using the "Play" button in the lefthand menu. </p>

                        <Form noValidate ref={this.form} onSubmit={event => this.saveChanges(event)}>
                            <Form.Group className="mb-3">
                                <Form.Check type="radio" id="use-builtin-music-yes" label="Use Built-in music" defaultChecked={this.state.usingBuiltInMusic} name="usingBuiltInMusic" onChange={() => this.customEnabled()} />
                                <Form.Check type="radio" id="use-builtin-music-no" label="Use Custom music" defaultChecked={!this.state.usingBuiltInMusic} name="usingBuiltInMusic" onChange={() => this.customEnabled()} />

                            </Form.Group>

                            {mainForm}
                            
                            <div className="button-footer-bar">
                                <Button variant="primary" type="submit">Save Changes</Button>
                            </div>
                        </Form>

                        {bottomStuff}
                    </Col>
                </Row>

            </Container>
        );
    }
}